import { Link } from "react-router-dom";
import { CaretRight, PlusCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/Button";
import { usePageMeta } from "@/hooks/usePageMeta";
import { slugFor, USE_CASES } from "./useCases";
import { getUseCaseContent } from "./useCasesContent";
import styles from "./UseCasesIndex.module.css";

export function UseCasesIndex() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "de";

  usePageMeta({
    title: t("pageMeta.useCasesIndexTitle"),
    description: t("pageMeta.useCasesIndexDescription"),
  });

  return (
    <article className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t("useCases.indexTitle")}</h1>
        <p className={styles.lead}>{t("useCases.indexLead")}</p>
      </header>

      <ul className={styles.grid}>
        {USE_CASES.map((uc) => {
          const content = getUseCaseContent(uc.id, lang);
          if (!content) return null;
          const Icon = uc.icon;
          return (
            <li key={uc.id}>
              <Link
                to={`/usefor/${slugFor(uc, lang)}`}
                className={`${styles.card} ${styles[`card_${uc.tone}`]}`}
              >
                <span className={styles.cardIcon}>
                  <Icon size={32} weight="regular" />
                </span>
                <div className={styles.cardBody}>
                  <h2 className={styles.cardTitle}>{content.shortLabel}</h2>
                  <p className={styles.cardTagline}>{content.tagline}</p>
                </div>
                <CaretRight size={18} weight="bold" aria-hidden className={styles.cardArrow} />
              </Link>
            </li>
          );
        })}
      </ul>

      <section className={styles.ctaBlock}>
        <h2 className={styles.ctaTitle}>{t("useCases.indexCtaTitle")}</h2>
        <p>{t("useCases.indexCtaLead")}</p>
        <Link to="/new" className={styles.ctaLink}>
          <Button className={styles.ctaButton}>
            <PlusCircle size={20} weight="regular" />
            {t("useCases.ctaButton")}
          </Button>
        </Link>
      </section>
    </article>
  );
}
